import React from 'react';
import { DivProps } from 'typings';
import UDInput from 'ud-form/components/input/component';
import UDText from '../text';

interface IProps extends Omit<DivProps, 'onChange'> {
  onChange: (value: number) => void;
  value: number;
}

function UDPerPage(props: IProps) {
  const { onChange, value, ...rest } = props;

  return (
    <div className="flex items-center text-nowrap" {...rest}>
      <UDText type="subhead" className="text-surfaceRomanSilver30 mr-2 ml-auto whitespace-nowrap">
        На странице:
      </UDText>
      <UDInput
        type="number"
        wrapperProps={{ className: 'w-[80px]' }}
        min={1}
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
      />
    </div>
  );
}

export default UDPerPage;
